import {Component} from 'vue-property-decorator';
import {LANGTAG, MD} from '../global_vars';
import {animateText, makeFormData, simpleObjectCopy} from '../utils/miscellanea';
import * as basicLightbox from 'basiclightbox';
import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';
import Event from '../utils/Event';
import ContactForm from '../mixins/ContactForm';
import {mixins} from 'vue-class-component';
import {State} from '../utils/fetch';
import {success, warning} from '../utils/Toast';
import Form from '../utils/Form';
import {delay} from '../utils/async';
import 'vue-js-modal';
import FormRequestCallback from "../components/form/FormRequestCallback";

declare function ym(a: number, b: string, c: string): void;

interface ContactData {
  name: string;
  phone: string;
  email: string;
  city: string;
  company: string;
  message: string;
  agreement: boolean;
}

@Component
export default class VMFrch3 extends mixins(ContactForm) {
  contactType = 'phone';

  public form = new Form<ContactData>({
    city: '',
    name: '',
    phone: '',
    company: '',
    message: '',
    email: '',
    agreement: false
  });

  protected requiredFields = ['name', 'city'];
  private lbInstance!: basicLightbox.BasicLightBox | null;

  async mounted() {
    if (LANGTAG == 'ru') {
      this.requiredFields.push('agreement');
    }

    Event.listen('close-agreement', () => {
      this.lbInstance?.close();
    });

    Event.listen('open-form-request-callback', this.openCBForm);

    if (!MD.mobile()) {
      animateText(<HTMLElement>this.$refs.title).then();
    }

    await delay(500);

    (this.$refs['promo4-bg'] as HTMLElement).classList.add('promo4__bg--active');
  }

  public async send() {
    this.checkForm();

    if (!this.isFormReady) return;

    if (this.form.data.phone == '' && this.form.data.email == '') {
      this.form.errors.add('phone', 'empty field');
      this.form.errors.add('email', 'empty field');
      return;
    } else {
      this.form.errors.clear('phone');
      this.form.errors.clear('email');
    }

    const form = makeFormData(simpleObjectCopy(this.form.data));
    form.append(this._token, '1');

    const response = await this._http.fetchJSON<any>(`/index.php?option=com_xcm&task=send_message`, {
      method: 'POST',
      body: form
    });

    if (response.state == State.SUCCESS) {
      success(response.body.message);
      this.form.errors.clear();
      this.form.clear();

      if (typeof ym === 'function') {
        ym(87096784, 'reachGoal', 'submit_form')
      }

      await delay(1000);

      location.href = '/ru/franchise/spasibo2';
    } else {
      warning(response.message, 'Ошибка');
    }
  }

  openAgreement(key: string) {
    this.lbInstance = basicLightbox.create(
      document.querySelector(`#agreement`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }

  openCBForm() {
    this.$modal.show(FormRequestCallback,
      {},
      {
        height: 'auto', width: '100%', maxWidth: 1152, adaptive: true, scrollable: true,
        transition: 'nice-modal-fade',
      },
    );
  }
}
